import axios from '../service/axios/axios';
export default {
    //获取健康商城商品类型列表
    getGoodsGroupList() {
        return axios({
            method: 'post',
            url: 'platform/tshop/getGoodsGroupList',
        });
    },
    //保存健康商城商品类型信息 group_id新增传0）
    saveGoodsGroupInfo({ group_id, group_name }) {
        return axios({
            method: 'post',
            url: 'platform/tshop/saveGoodsGroupInfo',
            data: { group_id, group_name }
        });
    },
    //健康商城商品类型排序
    editGoodsGroupSort({ list }) {
        return axios({
            method: 'post',
            url: 'platform/tshop/editGoodsGroupSort',
            data: { list }
        });
    },
    //删除健康商城商品类型信息
    deleteGoodsGroupInfo({ group_id }) {
        return axios({
            method: 'post',
            url: 'platform/tshop/deleteGoodsGroupInfo',
            data: { group_id }
        });
    },
    //获取健康商城商品列表 group_id所属分组，多个用逗号隔开
    getGoodsList(data) {
        return axios({
            method: 'post',
            url: 'platform/tshop/getGoodsList',
            data: data
        });
    },
    //健康商城商品移动到分组
    moveGoodsToGroup({ group_id, goods_id }) {
        return axios({
            method: 'post',
            url: 'platform/tshop/moveGoodsToGroup',
            data: { group_id, goods_id }
        });
    },
    //健康商城商品排序
    editGoodsSort(data) {
        return axios({
            method: 'post',
            url: 'platform/tshop/editGoodsSort',
            data: data
        });
    }
}